module.exports = __webpack_public_path__ + "img/2.0991e743.svg";